import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { BackgroundComponent } from './components/background/background.component';
import { CountUpDirective } from './directives/count-up.directive';
import { OnlyNumber } from './directives/only-number.directive';
import { TwoDigitDecimaNumberDirective } from './directives/two-decimal-number.directive';
import { NumberFormatPipe } from './pipes/number-format.pipe';
import { SafePipe } from './pipes/sanitizer.pipe';
import { SignificantDecimalPipe } from './pipes/significant-decimal.pipe';
import { TimeAgoPipe } from './pipes/time-ago.pipe';
import { TrimAddressPipe } from './pipes/trim-address.pipe';

@NgModule({
  declarations: [SafePipe, TrimAddressPipe, NumberFormatPipe, SignificantDecimalPipe, TimeAgoPipe, OnlyNumber, TwoDigitDecimaNumberDirective, CountUpDirective, BackgroundComponent,],
  imports: [CommonModule],
  exports: [SafePipe, TrimAddressPipe, NumberFormatPipe, SignificantDecimalPipe, TimeAgoPipe, OnlyNumber, TwoDigitDecimaNumberDirective, CountUpDirective, BackgroundComponent],
})
export class SharedModule { }
